<template>
  <div>
    <Header></Header>
    <div class="article_list">
      <p>乐器名称：{{instrument.name}}</p>
      <img v-bind:src="instrument.icon" alt="">
      <p>乐器Face：</p>
      <img v-bind:src="instrument.face" alt="">
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from '../../components/byl/header/header.vue'
import Footer from '../../components/footer.vue'
export default {
  components: { Header, Footer },
  data () {
    return {
      id: this.$route.params.id,
      list: [],
      instrument: {}
    }
  },
  created () {
    this.getInstrument()
  },
  methods: {
    getInstrument () {
      this.$api.post('/bt/btInstrument/search', null, r => {
        this.list = r.data
        for (var i = 0; i < this.list.length; i++) {
          if (this.list[i].id === this.id) {
            this.instrument = this.list[i]
          }
        }
        console.log(this.instrument)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/partyTraining/content.vue